import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title @label}}\n\n<BreadcrumbsItem>\n  <Ui::Link @route={{@route}} @model={{@model}} @query={{@query}} ...attributes>\n    {{@label}}\n  </Ui::Link>\n</BreadcrumbsItem>")